import React, { useEffect, useState } from 'react';
import useSize from '../../../../hooks/useSize';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { postUser } from '../../../../services/usersService';
import { useToast } from '../../../components/Toats';
import DateSelector from '../../../reports/reportsGeneration/TableReportsGeneration/components/DateInput';
import { SelectGlobal } from '../../../components/SelectGlobal';
import { useQuery } from 'react-query';
import { getplantsAll } from '../../../../services/plantsService';
import { getCompanyAll } from '../../../../services/companyService';

const validationSchema = Yup.object().shape({
    dateInit: Yup.string().required(),
    dateEnd: Yup.string().email().required(),
    available: Yup.boolean(),
    status: Yup.string(),
    idPlant: Yup.string(),
    idCompany: Yup.string(),
});

export function CreateReportsAllDate({myRefresh, setMyRefresh}: any) {
    const {width} = useSize();
    const [loading, setLoading] = useState<boolean>(false);
    const { toggleToast } = useToast();
    const [showDetailsAppModal, setShowDetailsAppModal] = useState(false);
    const [saveResult, setSaveResult] = useState<any>(null)
    const [hasError, setHasError] = useState(false)

  const [initialValues, setInitialValues] = useState<any>({
    dateInit: new Date(),
    dateEnd: new Date(),
    available: false,
    status: "IMCOMPLETO",
    idPlant: null,
    idCompany: null,
  })

  const checkInputs = (): boolean => {
    if (!formik.values.dateInit 
        || !formik.values.dateEnd
      ) {
      return false
    }
    return true
  }

  const nextStep = () => {
    setHasError(false)

    if (!checkInputs()) {
        setHasError(true)
        return
    }
    //AddEmpresaUser()
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: () => {},
  });


  const { data: plants, isLoading: loadingMyPlants, refetch: refreshPlants } = useQuery<any[]>(
    ["getPlants"],
    async () => {
      const myPlants = await getplantsAll();
      return myPlants
    },
    {
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar as usinas. ", "error");
      },
    }
  )

  const { data: companies, isLoading: loadingCompanies } = useQuery<any>(
    ["getMyCompaniesUser"],
    async () => {
      const myCompanies = await getCompanyAll()
      return myCompanies;
    },
    {
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar empresas. ", "error")
      },
    }
  )

  // const AddEmpresaUser = async () => {
  //   try {
  //     setLoading(true)
  //     const myData = {
  //       name: formik.values.name,
  //       email: formik.values.email,
  //       corporateName: formik.values.corporateName,
  //       plano: "BASE",
  //       planos: "BASE",
  //       cnpj: formik.values.cnpj,
  //       qtd_plants_plano: formik.values.qtd_plants_plano,
  //       qtd_plants_gratuita: formik.values.qtd_plants_gratuita,
  //       qtd_plants_plano_starter: formik.values.qtd_plants_plano_starter
  //     }

  //     const result = await postUser(myData, "EMPRESA")
  //     setSaveResult(result)
  //     toggleToast("Sucesso ao cadastrar a empresa ", "success")

  //   } catch (error: any) {
  //     console.log('erro',error)
  //     //toggleToast("Erro ao cadastrar a empresa. ", "error")

  //     toggleToast(
  //       error && error.response 
  //       && error.response.data 
  //       && error.response.data.message 
  //       ? error.response.data.message 
  //       : "Erro ao cadastrar a empresa. ", 
  //       "error"
  //     )
  //   }finally{
  //     setLoading(false)
      
  //     formik.setValues(initialValues);
  //     setMyRefresh((prev: boolean) => !prev);
  //     setShowDetailsAppModal(true)
  //   }
  // }

  const submit = () => {
    nextStep()
    // AddEmpresaUser()
  }

  const dynamicStyle = width < 1400
  ? { height: 'auto', paddingTop: '0rem' }
  : { overflow: 'auto' };

  return (
    <div className={`card card-xl-stretch mb-xl-8`} style={{paddingBottom: '1rem'}}>
        <div 
          className='card-header border-0 pt-6'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#add_reports_all_date'
          aria-expanded='true'
          aria-controls='add_reports_all_date'
          style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', flexWrap: 'nowrap'}}
        >
          <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold fs-3 mb-1'>Cadastro de relatorios (datas)</span>
              <span className='text-muted mt-1 fw-semibold fs-7'>Cadastre novos relatorios (Por intervalos de meses)</span>
          </h3>

          <i className="bi bi-caret-down-fill fs-7"></i>
        </div>

        <div className='collapse show' id='add_reports_all_date'>
          <div className='card-body py-3 pb-5 pt-5' style={dynamicStyle}>
            <div className='separator border-gray-200 mb-3'></div>
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <div style={{ flex: '4', minWidth: '200px' }}>
                
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className='row mb-1'>
                      <label className='col-lg-4 col-md-5 col-sm-12 col-form-label required fw-bold fs-6 text-truncate' title='Nome da Empresa'>
                        Data Inicial
                      </label>
                      <div className='col-lg-8 col-md-7 col-sm-12 fv-row'>
                        <DateSelector 
                          selectedDate={formik.values.dateInit}
                          setSelectedDate={() => {}}
                        />
                      </div>
                    </div>

                    <div className='row mb-1'>
                      <label className='col-lg-4 col-md-5 col-sm-12 col-form-label required fw-bold fs-6 text-truncate' title='CNPJ'>
                        Data Final
                      </label>
                      <div className='col-lg-8 col-md-7 col-sm-12 fv-row'>
                        <DateSelector 
                          selectedDate={formik.values.dateEnd}
                          setSelectedDate={() => {}}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ flex: '4', minWidth: '200px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className='row mb-1'>
                      <label className='col-lg-4 col-md-5 col-sm-12 col-form-label required fw-bold fs-6 text-truncate' title='Nome do Usuário'>
                        Disponibilidade para cliente
                      </label>
                      <div className='col-lg-8 col-md-7 col-sm-12 fv-row'>

                        <SelectGlobal 
                          //itens={collaborators}
                          itens={[{available: "true"}, {available: "false"}]}
                          buttonAll={true}
                          textSearch={"Buscar disponibilidade"}
                          textButtonInit={"Filtrar por disponibilidade"}
                          labelKey='available'
                          valueKey='available'
                          //typeIcon='img'
                          //setPagination={setPagination}
                          value={formik.values.available ? "true" : "false"}
                          className={"w-100"}
                          onChange={(value: string) => {
                            //setFilterStatus ? setFilterStatus(value) : console.log('Sem função de filtro')
                          }}
                        />
                      </div>
                    </div>

                    <div className='row mb-2'>
                      <label className='col-lg-4 col-md-5 col-sm-12 col-form-label required fw-bold fs-6 text-truncate' title='E-mail do Usuário'>
                        Status
                      </label>
                      <div className='col-lg-8 col-md-7 col-sm-12 fv-row'>
                        <SelectGlobal 
                          //itens={collaborators}
                          itens={[{name: "IMCOMPLETO"}, {name: "GERADO"}]}
                          buttonAll={true}
                          textSearch={"Buscar status"}
                          textButtonInit={"Filtrar por status"}
                          labelKey='name'
                          valueKey='name'
                          //typeIcon='img'
                          //setPagination={setPagination}
                          value={formik.values.status ? formik.values.status : ""}
                          className={"w-100"}
                          onChange={(value: string) => {
                            //setFilterStatus ? setFilterStatus(value) : console.log('Sem função de filtro')
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ flex: '5', minWidth: '250px'}}>
                  <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', flexDirection: 'column'}}>
                    <div className='row' style={{minWidth: '100px'}}>
                      <label className='col-lg-4 col-md-5 col-sm-12 col-form-label required fw-bold fs-6 text-nowrap'>Usina</label>
                      <div className='col-lg-8 col-md-7 col-sm-12 fv-row'>
                        <SelectGlobal 
                          //itens={collaborators}
                          itens={plants}
                          buttonAll={true}
                          textSearch={"Buscar por nome"}
                          textButtonInit={"Filtrar por usina"}
                          labelKey='name'
                          valueKey='id'
                          //typeIcon='img'
                          //setPagination={setPagination}
                          value={formik.values.idPlant ? formik.values.idPlant : ""}
                          className={"w-100"}
                          onChange={(value: string) => {
                            //setFilterStatus ? setFilterStatus(value) : console.log('Sem função de filtro')
                          }}
                        />
                      </div>
                    </div>

                    <div className='row' style={{minWidth: '100px'}}>
                      <label className='col-lg-4 col-md-5 col-sm-12 col-form-label required fw-bold fs-6 text-nowrap'>Empresa</label>
                      <div className='col-lg-8 col-md-7 col-sm-12 fv-row'>
                      <SelectGlobal 
                        itens={companies}
                        buttonAll={true}
                        textSearch={`Buscar por nome da corporação`}
                        textButtonInit={`Filtrar por empresa`}
                        labelKey={`corporateName`}
                        valueKey='id'
                        //setPagination={setPagination}
                        value={formik.values.idCompany ? formik.values.idCompany : ""}
                        className={"w-100"}
                        loading={loadingCompanies}
                        onChange={(value: string) => {
                          //setFilterCompany ? setFilterCompany(value) : console.log('Sem função de filtro')
                        }}
                      />
                      </div>
                    </div>

                    {/* <div className='row' style={{minWidth: '100px', maxWidth: '250px'}}>
                      <label className='col-lg-4 col-md-5 col-sm-12 col-form-label required fw-bold fs-6 text-nowrap'>BÁSICAS</label>
                      <div className='col-lg-8 col-md-7 col-sm-12 fv-row'>
                        <input
                          type='number'
                          className='form-control form-control-lg form-control-solid'
                          placeholder='0'
                          value={formik.values.qtd_plants_gratuita}
                          onChange={formik.handleChange('qtd_plants_gratuita')}
                        />
                      </div>
                    </div> */}

                    {/* {!formik.values.qtd_plants_plano &&
                      !formik.values.qtd_plants_plano_starter &&
                      !formik.values.qtd_plants_gratuita &&
                      hasError && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            Informe uma quantidade de usinas em pelo menos 1 dos planos
                          </div>
                        </div>
                      )} */}
                  </div>
                </div>
              </div>
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>              
              <button 
                  type='button' 
                  disabled={loading}
                  onClick={() => {
                      submit()
                      //setMyRefresh((prev: boolean) => !prev);
                  }} 
                  className='btn btn-primary'
              >
                  {!loading && 'Salvar Empresa'}
                  {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                      Salvando...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                  )}
              </button>
          </div>
        </div>
    </div>
  );
}